import { KeyboardEvent } from "react";
import { maskJs } from "mask-js";

function cep(e: KeyboardEvent<HTMLInputElement>) {
  e.currentTarget.maxLength = 9;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{5})(\d)/, "$1-$2");
  e.currentTarget.value = value;
  return e;
}

function cepMask(value:string) {
 const cepValue = value?.replace(/^(\d{5})(\d)/, "$1-$2");
  return cepValue;
}

function cellPhone(e: KeyboardEvent<HTMLInputElement>) {
  e.currentTarget.maxLength = 15;

  var tel = e.currentTarget.value;

  tel = tel.replace(/\D/g, "");
  tel = tel.replace(/^(\d)/, "($1");
  tel = tel.replace(/(.{3})(\d)/, "$1) $2");
  tel = tel.replace(/(.{10})(\d)/, "$1-$2");

  e.currentTarget.value = tel;

  return e;
}

function phone(e: KeyboardEvent<HTMLInputElement>) {
  e.currentTarget.maxLength = 14;

  var tel = e.currentTarget.value;

  tel = tel.replace(/\D/g, "");
  tel = tel.replace(/^(\d)/, "($1");
  tel = tel.replace(/(.{3})(\d)/, "$1) $2");
  tel = tel.replace(/(.{9})(\d)/, "$1-$2");

  e.currentTarget.value = tel;

  return e;
}

function paymentRange(e: KeyboardEvent<HTMLInputElement>) {
  e.currentTarget.maxLength = 6;

  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  e.currentTarget.value = `D + ${value}`;
  return e;
}

function cpf(e: KeyboardEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;

  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d{1,2})/, "$1-$2");
  value = value.replace(/(-\d{2})\d+?$/, "$1");

  e.currentTarget.value = value;

  return e;
}

function cnpj(e: KeyboardEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{2})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1/$2");
  value = value.replace(/(\d{4})(\d{1,2})/, "$1-$2");
  value = value.replace(/(-\d{2})\d+?$/, "$1");
  e.currentTarget.value = value;
  return e;
}

function digit(e: KeyboardEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;
  const regex = /^[01]$/;
  if(!regex.test(value)) {
    value = ""
    e.currentTarget.value = value;
  }
  return e
}

function currency(e: KeyboardEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;
  value = parseFloat(
    value
      .replace(/(.*){1}/, "0$1")
      .replace(/[^\d]/g, "")
      .replace(/(\d\d?)$/, ".$1")
  ).toFixed(2);
  value = value.replace(".", ",");
  e.currentTarget.value = `R$ ${value}`;
  return e;
}

function currencyE(e: KeyboardEvent<HTMLInputElement>, noBrSign?: boolean) {
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{1})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

  if (noBrSign) {
    e.currentTarget.value = value;
    return e;
  }

  e.currentTarget.value = `R$ ${value}`;

  return e;
}

function percentageE(e: KeyboardEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  
  e.currentTarget.value = `${value}%`;
  return e;
}

function percentageRacional(e: KeyboardEvent<HTMLInputElement>, onBlur?: boolean) {
  let value = e.currentTarget.value;
  if ( onBlur ) {
    if (e.currentTarget.value.length > 0) {
      value = value.replace("%", "");
      e.currentTarget.value = `${value}%`;
    }
   return e;
  } 
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{1})$/, "$1,$2");
  e.currentTarget.value = value;
  return e;
}

function percentage(e: KeyboardEvent<HTMLInputElement>) {
    if(Number(e.currentTarget.value) >= 100) {
      e.currentTarget.value = "100"
      return e;
    }
    return e;
}

// function currency(e: KeyboardEvent<HTMLInputElement>) {
//   let value = e.currentTarget.value;
//   value = value.replace(/\D/g, "");
//   value = value.replace(/(\d)(\d{2})$/, "$1,$2");
//   value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

//   e.currentTarget.value = `R$ ${value}`;
//   return e;
// }

function card(e: KeyboardEvent<HTMLInputElement>) {
  e.currentTarget.maxLength = 19;

  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{4})(?=\1)/g, "$1 ");

  e.currentTarget.value = value;
  return e;
}

function simpleDate(e: KeyboardEvent<HTMLInputElement>) {
  if((e.key === "Backspace" || e.key === "Delete")) return 
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{2})/, "$1/");
  value = value.replace(/^(\d{2})\/(\d{2})/, "$1/$2/");
  const dia = value.substring(0, 2);
  const mes = value.substring(3, 5);
  const ano = value.substring(6, 10);
  if (Number(dia) > 31) {
    value = "31/" + mes + "" + ano;
  } else if (Number(mes) > 12) {
    value = dia + "/12" + ano;
  }
  e.currentTarget.value = value;
  return e;
}

function cpf_cnpj(value: string) {
  if (value.length <= 11) {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})/, "$1-$2");
    value = value.replace(/(-\d{2})\d+?$/, "$1");
    return value;
  } else {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})(\d{1,2})/, "$1-$2");
    value = value.replace(/(-\d{2})\d+?$/, "$1");
    return value;
  }
}

function phone_format(cellphone: string) {
  if (cellphone.length === 10) {
    let mask = maskJs("(99) 9999-9999", cellphone);
    return mask;
  }
  let mask = maskJs("(99) 9 9999-9999", cellphone);
  return mask;
}

function clearMask(value: string) {
  return value?.replace(/[^a-zA-Z0-9 ]/g, "")?.replaceAll(" ", "");
}

function formatDateToAPI(value) {
  if (!value || !/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return null;
  const [day, month, year] = value.split('/');
  return `${year}-${month}-${day}`;
}

function formatDateToBR(value) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
}

export type MaskTypes =
  | "cep"
  | "cepMask"
  | "currency"
  | "cpf"
  | "cellPhone"
  | "phone"
  | "cnpj"
  | "card"
  | "simpleDate"
  | "clearMask"
  | "cpf_cnpj"
  | "phone_format"
  | "paymentRange"
  | "currencyE"
  | "percentageE"
  | "percentageRacional";

export {
  cep,
  cepMask,
  currency,
  cpf,
  cellPhone,
  phone,
  cnpj,
  card,
  simpleDate,
  clearMask,
  cpf_cnpj,
  phone_format,
  percentage,
  paymentRange,
  currencyE,
  percentageE,
  percentageRacional,
  digit,
  formatDateToAPI,
  formatDateToBR
};
